"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EyeCrossedIcon = require("./EyeCrossedIcon");
Object.keys(_EyeCrossedIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EyeCrossedIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EyeCrossedIcon[key];
    }
  });
});
var _EyeIcon = require("./EyeIcon");
Object.keys(_EyeIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EyeIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EyeIcon[key];
    }
  });
});